import type { ReactNode } from 'react';
import { Popover, Typography } from 'antd';
import { getTerm } from './contentLoader';
import { MdBlocks } from './markdown';

const { Text } = Typography;

/**
 * Glossary hover (OPSFL-HELP-1): resolves a term id from `content/glossary.md` and wraps its
 * children (or the display term) in a hover Popover with the definition. Degrades: an unknown id
 * (or a not-yet-written glossary) renders the children/id as plain text — never a crash.
 */
export function Term({ id, children }: { id: string; children?: ReactNode }) {
  const entry = getTerm(id);
  if (!entry) return <>{children ?? id}</>;

  const content = (
    <div style={{ maxWidth: 320, fontSize: 12.5 }}>
      <MdBlocks markdown={entry.definition} />
    </div>
  );

  return (
    <Popover title={entry.display} content={content} placement="top">
      <Text
        style={{
          cursor: 'help',
          textDecoration: 'underline dotted var(--ol-text-tertiary)',
          textUnderlineOffset: 3,
        }}
      >
        {children ?? entry.display}
      </Text>
    </Popover>
  );
}
